import React from 'react';

const fakePosts = [
  {
    id: 1,
    author: 'Senthil Kumar',
    role: 'Freelancer',
    content: 'Completed 3 landing pages today and got great client feedback! 💼',
    time: '2 hours ago',
  },
  {
    id: 2,
    author: 'Senthil Kumar',
    role: 'Investor',
    content: 'Reviewed 2 new startup pitches. One is promising! 🚀',
    time: 'Yesterday',
  },
];

export default function DashboardPostFeed() {
  return (
    <div className="space-y-4">
      <h2 className="text-md font-semibold mb-2">🗂️ Your Recent Updates</h2>

      {fakePosts.map((post) => (
        <div key={post.id} className="bg-black shadow rounded-lg p-4">
          <div className="flex justify-between items-center mb-1">
            <span className="text-sm font-bold text-blue-700">{post.author}</span>
            <span className="text-xs text-gray-400">{post.time}</span>
          </div>
          <div className="text-xs text-gray-500 mb-2">🧠 {post.role}</div>
          <p className="text-sm text-gray-800">{post.content}</p>
        </div>
      ))}
    </div>
  );
}
